import GasInputForm from "../offices/GasInputForm";

import { useGasInputProps } from "../../../helpers/components/inputs";

const useGasInput = ({ transaction, onSave }) => {
  const { status } = transaction;
  const {
    gasCarbonTons,
    gasUnit,
    setGasUnit,
    gasUnitValue,
    setGasUnitValue,
    fuelType,
    setFuelType,
    saveEnabled,
    saveObject,
  } = useGasInputProps(transaction);

  const inputBlock = (
    <GasInputForm
      fuelType={fuelType}
      setFuelType={setFuelType}
      gasUnit={gasUnit}
      setGasUnit={setGasUnit}
      unitValue={gasUnitValue}
      setUnitValue={setGasUnitValue}
      disabled={status === "locked"}
    />
  );

  const onTransactionSave = () =>
    onSave({
      tonsCo2e: gasCarbonTons,
      emissionData: saveObject.emissionData,
    });

  return {
    inputBlock,
    onTransactionSave,
    saveEnabled,
    tonsCo2e: gasCarbonTons,
  };
};
export default useGasInput;
